<div
    class="agpr-performanceTrackingCard-summary-column"
    role="group"
    [attr.aria-label]="rateLabel | localize"
>
    <div
        class="agpr-performanceTrackingCard-header"
        [ngClass]="{
            'agpr-performanceTrackingCard-header-rateNotAvailable': !trackingEnabled
        }"
    >
        <h5 class="agpr-performanceTrackingCard-header-label">
            {{ rateLabel | localize }}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-performanceTrackingCard-infoCircle"
                [agprTooltip]="rateLabelTooltip"
                [escape]="false"
            ></span>
        </h5>

        <div class="agpr-performanceTrackingCard-header-value">
            <span
                class="agpr-performanceTrackingCard-header-bigNumber"
                [pTooltip]="stats.tooltip | localize"
                [ngClass]="{
                    'agpr-performanceTrackingCard-na': stats.rate === 'N/A'
                }"
            >
                {{ stats.rate }}
            </span>
            @if (showEstimatedTag) {
                <span class="agpr-performanceTrackingCard-estimatedTag">
                    {{ 'Discover.distribution.statistics.estimated' | localize }}
                </span>
            }
            @if (statisticReportSourceType === statisticReportSourceTypeEnum.DISTRIBUTION && trackingEnabled) {
                @if (data.rateChange < 0) {
                    <span
                        class="agpr-performanceTrackingCard-statistic-benchmarkDifference agpr-performanceTrackingCard-statistic-benchmarkDifference--negative"
                        [pTooltip]="rateTooltip"
                    >
                        <span class="fa-regular fa-arrow-down-right" aria-hidden="true"></span>
                        {{ stats.rateChange }}
                    </span>
                }
                @if (data.rateChange >= 0) {
                    <span
                        class="agpr-performanceTrackingCard-statistic-benchmarkDifference agpr-performanceTrackingCard-statistic-benchmarkDifference--positive"
                        [pTooltip]="rateTooltip"
                    >
                        <span class="fa-regular fa-arrow-up-right" aria-hidden="true"></span>
                        {{ stats.rateChange }}
                    </span>
                }
                @if (data.rateChange | isNaN) {
                    <span
                        class="agpr-performanceTrackingCard-statistic-benchmarkDifference agpr-performanceTrackingCard-statistic-benchmarkDifference--NaN"
                    >
                        {{ "-- %" }}
                    </span>
                }
            }
        </div>
    </div>

    <div class="agpr-performanceTrackingCard-details">
        <ng-container
            *ngTemplateOutlet="
                statSubCard;
                context: {
                    label: uniqueLabel,
                    tooltip: uniqueLabelTooltip,
                    value: stats.unique,
                    statistics: uniqueStatistics,
                    expanded: uniqueExpanded,
                    toggle: toggleUniqueExpand.bind(this)
                }
            "
        ></ng-container>
        <ng-container
            *ngTemplateOutlet="
                statSubCard;
                context: {
                    label: totalLabel,
                    tooltip: totalLabelTooltip,
                    value: stats.total,
                    statistics: totalStatistics,
                    expanded: totalExpanded,
                    toggle: toggleTotalExpand.bind(this)
                }
            "
        ></ng-container>
    </div>
</div>

<ng-template
    #statSubCard
    let-label="label"
    let-tooltip="tooltip"
    let-value="value"
    let-statistics="statistics"
    let-expanded="expanded"
    let-toggle="toggle"
>
    <agpr-panel
        class="agpr-performanceTrackingCard-subCard"
        [toggleable]="!!statistics?.length"
        [collapsed]="!expanded"
        [contentPadding]="false"
        [paddingBottom]="0"
        [noBorder]="true"
        (collapsedChange)="toggle()"
        [toggleArrowTooltip]="
            !expanded
                ? 'Discover.distribution.statistics.moreDetails'
                : 'Discover.distribution.statistics.lessDetails'
        "
    >
        <ng-template #panelHeader>
            <div
                class="agpr-performanceTrackingCard-subCard-header"
                role="group"
                [attr.aria-label]="label | localize"
            >
                <span class="agpr-performanceTrackingCard-subCard-header-label">
                    {{ label | localize }}
                    <span
                        role="img"
                        class="fa-regular fa-circle-info agpr-performanceTrackingCard-infoCircle"
                        [agprTooltip]="tooltip"
                        [escape]="false"
                    ></span>
                </span>
                <span
                    class="agpr-performanceTrackingCard-subCard-header-value"
                    [pTooltip]="stats.tooltip | localize"
                    [ngClass]="{
                        'agpr-performanceTrackingCard-na': value === 'N/A'
                    }"
                >
                    {{ value }}
                </span>
                @if (showEstimatedTag) {
                    <span class="agpr-performanceTrackingCard-estimatedTag">
                        {{ 'Discover.distribution.statistics.estimated' | localize }}
                    </span>
                }
            </div>
        </ng-template>
        @if (statistics?.length) {
            <div class="agpr-performanceTrackingCard-subCard-expanded">
                @for (statistic of statistics; track statistic) {
                    <div
                        class="agpr-performanceTrackingCard-subCard-expanded-row"
                        [ngClass]="{
                            'agpr-performanceTrackingCard-subCard-expanded-row-emphasize': statistic.emphasize
                        }"
                    >
                        <span class="agpr-performanceTrackingCard-subCard-expanded-row-label">
                            {{ statistic.label | localize }}
                            <span
                                role="img"
                                class="fa-regular fa-circle-info agpr-performanceTrackingCard-infoCircle"
                                [escape]="false"
                                [agprTooltip]="statistic.info"
                            ></span>
                        </span>
                        <span class="agpr-performanceTrackingCard-subCard-expanded-row-count">
                            {{ statistic.count }}
                        </span>
                    </div>
                }
            </div>
        }
    </agpr-panel>
</ng-template>
